<template>
  <footer class="d-none">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="footer-wrapper">
            <ul>
              <li>
                <a href="#">#instagram</a>
              </li>
              <li>
                <a href="#">#telegram</a>
              </li>
            </ul>
            <div class="copyright">
              &copy; {{year}} <span> ux.im</span> / ver1.0
            </div>
            <div class="designed_by d-flex align-items-center">
              <div class="name">Developed by</div>
              <a href="#"><img src="/images/logo-dark.svg" alt="uxlove studio"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name    : 'AdminFooter',
    computed: {
      year() {
        const d = new Date();
        return d.getUTCFullYear();
      }
    }
  }
</script>